// General
import Badge from "./Badge";
import Button from "./Button";
import DetailListItem from "./DetailListItem";
import EvolutionChart from "./EvolutionChart";
import IconLink from "./IconLink";
import IconPicker from "./IconPicker";
import InputField from "./InputField";
import ListItem from "./ListItem";
import LoadingButton from "./LoadingButton";
import Milestone from "./Milestone";
import Person from "./Person";
import PersonContentLoader from "./PersonContentLoader";
import Post from "./Post";
import PostContentLoader from "./PostContentLoader";
import Reflection from "./Reflection";
import ProfileCard from "./ProfileCard";
import QandA from "./QandA";
import ReadMore from "./ReadMore";
import TextAreaField from "./TextAreaField";
import Upload from "./Upload";
import ValueSelector from "./ValueSelector";
import VisitCard from "./VisitCard";
// Modals
import CategoryModal from "./Modals/CategoryModal";
import CommentModal from "./Modals/CommentModal";
import CreateMilestoneModal from "./Modals/CreateMilestoneModal";
import EditPostModal from "./Modals/EditPostModal";
import GalleryPrivacyModal from "./Modals/GalleryPrivacyModal";
import LikedModal from "./Modals/LikedModal";
import MilestoneModal from "./Modals/MilestoneModal";
import NurseModal from "./Modals/NurseModal";
import ShareModal from "./Modals/ShareModal";
import SurveyModal from "./Modals/SurveyModal";
import TagModal from "./Modals/TagModal";
import VisitModal from "./Modals/VisitModal";
// Dictionary
import AddedDictionaryEntries from "./Dictionary/AddedDictionaryEntries";
import AddedTags from "./Dictionary/AddedTags";
import DictionarySelector from "./Dictionary/DictionarySelector";
import TagSelector from "./Dictionary/TagSelector";

const PageElements = {
  install(Vue) {
    // General
    Vue.component(Badge.name, Badge);
    Vue.component(Button.name, Button);
    Vue.component(DetailListItem.name, DetailListItem);
    Vue.component(EvolutionChart.name, EvolutionChart);
    Vue.component(IconLink.name, IconLink);
    Vue.component(IconPicker.name, IconPicker);
    Vue.component(InputField.name, InputField);
    Vue.component(ListItem.name, ListItem);
    Vue.component(LoadingButton.name, LoadingButton);
    Vue.component(Milestone.name, Milestone);
    Vue.component(Person.name, Person);
    Vue.component(PersonContentLoader.name, PersonContentLoader);
    Vue.component(Post.name, Post);
    Vue.component(PostContentLoader.name, PostContentLoader);
    Vue.component(Reflection.name, Reflection);
    Vue.component(ProfileCard.name, ProfileCard);
    Vue.component(QandA.name, QandA);
    Vue.component(ReadMore.name, ReadMore);
    Vue.component(TextAreaField.name, TextAreaField);
    Vue.component(Upload.name, Upload);
    Vue.component(ValueSelector.name, ValueSelector);
    Vue.component(VisitCard.name, VisitCard);
    // Modals
    Vue.component(CategoryModal.name, CategoryModal);
    Vue.component(CommentModal.name, CommentModal);
    Vue.component(CreateMilestoneModal.name, CreateMilestoneModal);
    Vue.component(EditPostModal.name, EditPostModal);
    Vue.component(GalleryPrivacyModal.name, GalleryPrivacyModal);
    Vue.component(LikedModal.name, LikedModal);
    Vue.component(MilestoneModal.name, MilestoneModal);
    Vue.component(NurseModal.name, NurseModal);
    Vue.component(ShareModal.name, ShareModal);
    Vue.component(SurveyModal.name, SurveyModal);
    Vue.component(TagModal.name, TagModal);
    Vue.component(VisitModal.name, VisitModal);
    // Dictionary
    Vue.component(AddedDictionaryEntries.name, AddedDictionaryEntries);
    Vue.component(AddedTags.name, AddedTags);
    Vue.component(DictionarySelector.name, DictionarySelector);
    Vue.component(TagSelector.name, TagSelector);
  }
};

export { PageElements };
